"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTypeToJSON = exports.EventTypeFromJSONTyped = exports.EventTypeFromJSON = exports.EventType = void 0;
/**
 * The type of event.
 * @export
 */
exports.EventType = {
    PageView: 'PAGE_VIEW',
    Lead: 'LEAD',
    Purchase: 'PURCHASE',
    AddToCart: 'ADD_TO_CART'
};
function EventTypeFromJSON(json) {
    return EventTypeFromJSONTyped(json, false);
}
exports.EventTypeFromJSON = EventTypeFromJSON;
function EventTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.EventTypeFromJSONTyped = EventTypeFromJSONTyped;
function EventTypeToJSON(value) {
    return value;
}
exports.EventTypeToJSON = EventTypeToJSON;
